module.exports = __webpack_public_path__ + "img/Apple-store.a6bab731.svg";